import {Badge, ButtonToolbar, DropdownButton} from 'react-bootstrap';
import createReactClass from 'create-react-class';
import newlineToBr from '../global/libs/newlineToBr.js';
import PropTypes from 'prop-types';
import './AnswerPanelTable.css';
import './Common.css';

let AnswerPanelTableQuestionsTr = createReactClass({
  // ARGS: result
  propTypes: {
    result: PropTypes.object.isRequired
  },

  render: function () {
    let result = this.props.result;
    let resultCategory = result.category ? '＜' + result.category + '＞' : '';

    let category = <span style={{fontSize: '75%', marginLeft: '-36px'}}>{resultCategory}</span>;

    let resultQuestion = result.question ? result.question : '';

    let questionLines = newlineToBr(resultQuestion);
    let mainQuestion = <span dangerouslySetInnerHTML={questionLines}></span>;

    let subQuestions = !('paraphrases' in result)
      ? []
      : result.paraphrases.map(function (e, idx) {
          return <li key={'li' + idx}>{e}</li>;
        });

    let iimawashiBtnDisabled = subQuestions.length === 0;
    let titleText = (
      <span>
        他の言い回し <Badge pill>{subQuestions.length}</Badge>
      </span>
    );
    let iimawashiBtn = (
      <ButtonToolbar>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              '.dropdown-menu {width:85vw; max-width:660px; height:auto; max-height:200px; overflow-x:hidden; padding-top:10px; padding-bottom:10px; background-color:#f9f9f9;}'
          }}
        />
        <DropdownButton
          title={titleText}
          id="dropdown-size-extra-small"
          disabled={iimawashiBtnDisabled}
          variant="outline-secondary"
          size="sm"
        >
          <ul style={{listStyleType: 'square'}}>{subQuestions}</ul>
        </DropdownButton>
      </ButtonToolbar>
    );

    if (subQuestions.length === 0) {
      // hide button when there is no subQuestions
      iimawashiBtn = <span />;
    }

    return (
      <tr className="question-text">
        <td style={{width: '33px', paddingTop: '15px', paddingBottom: '15px'}}>
          <span style={{fontSize: '75%'}}> </span>
          <br />
          Q:
        </td>
        <td colSpan="2" style={{paddingTop: '15px', paddingBottom: '0px'}}>
          {category}
          <br />
          {mainQuestion}
          <p className="float-sm-end">{iimawashiBtn}</p>
        </td>
      </tr>
    );
  }
});

export default AnswerPanelTableQuestionsTr;
